import React, { Component } from 'react';
import { connect } from 'react-redux';
import { t } from 'ttag';
import ConfigurationActions from '../../redux/configurationRedux';
import PartsActions from '../../redux/partsRedux';
import style from '../scenes.scss';
import { isNil } from '../../services/helper';

// Components
import EngineBox from '../../components/selectionBoxes/engineBox/engineBoxComponent';
import SceneNotice from '../../components/notice/sceneNoticeComponent';
import resolvePrice from '../../services/helper/resolvePrice';
import checkMarkedDependency from '../../services/helper/checkMarkedDependency';

class EngineScene extends Component {

    componentWillMount() {
        this.listItems();
    }

    listItems = () => {
        const { listPartsRequest, parts, configuration } = this.props;
        if (isNil(parts.engines) || configuration.refreshing) {
            listPartsRequest('all', configuration.model.id);
            this.props.setRefreshing(false);
        }
    }

    resolvePrice = (part, serialParentUid) => resolvePrice(
      part, serialParentUid, this.props.configuration.configurations
    );

    renderEngineItems = () => {
        const { parts, configuration } = this.props;

        if (isNil(parts.engines)) {
            return null;
        }

        const onSelectItem = (engine) => {
            if (!isNil(engine)) {
                this.props.updateConfiguration('engine', engine, parts);
            }
        };

        const listItems = parts.engines.data.map((engineItem) => (
            <EngineBox
                key={engineItem.uid}
                engine={engineItem}
                selectedItem={configuration.configurations.engine}
                onSelectItem={(item) => onSelectItem(item)}
                resolvePrice={this.resolvePrice}
                markedDependencies={configuration.markedDependencies}
            />
        ));
        return (
            <div className={style.form_container}>
                {listItems}
            </div>
        );
    }

    render() {
        const { parts, configuration } = this.props;

        if (this.props.fetching === null || this.props.fetching === true) {
            return (
                <h2>{t`LADE`}</h2>
            );
        }

        let hasMarkedDependency = false;
        hasMarkedDependency = checkMarkedDependency(
            parts.engines.data,
            configuration.markedDependencies
        );

        return (
            <div className={style.scene} >
                <div className={style.title}>
                    <h2>{t`Motorisierung wählen`}</h2>
                </div>
                <form>
                    {
                        hasMarkedDependency ?
                            <SceneNotice content={t`Sie haben nun die Möglichkeit Ihre Konfiguration zu ändern. Eine Änderung kann ggf. Auswirkungen auf die bestehende Konfiguration haben. Bitte prüfen Sie die folgenden Einstellungen!`} />
                            : null
                    }
                    {this.renderEngineItems()}
                </form>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    caravans: state.caravans.caravans,
    parts: state.parts.parts,
    fetching: state.parts.fetching,
    configuration: state.configuration,
});

const mapDispatchToProps = dispatch => ({
    updateConfiguration: (category, value, parts) =>
        dispatch(ConfigurationActions.updateConfiguration(category, value, parts)),
    listPartsRequest: (category, identifier) =>
        dispatch(PartsActions.listPartsRequest(category, identifier)),
    setRefreshing: (refresh) =>
        dispatch(ConfigurationActions.setRefreshing(refresh)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EngineScene);
